export default __webpack_public_path__ + "static/media/jedzcochcesz-light.fd1013f7.svg";